import { Box, Checkbox, Grid, Typography } from '@mui/material';
import React from 'react';
import { Applicant, ApplicationProps } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { KeyValue } from '../ApplicationDetails/contributor';
import { Gridstyles, Item, ItemDetails } from '../ApplicationDetails';
import { SubHeading } from '../investors/components';
import {
  checkValidationBasedOnDate,
  currencyConversion,
  getclIdField,
  getdpIdField,
  isCDSL,
  isDprFieldApplicable,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import {
  DLCLMasters,
  investorTypeMasters,
  REtypeMaster,
  reTypeValidationDate,
  YES_NO_MASTER,
} from '../../utils/constant';
import { isNotNPODeclaration, isNPODeclaration } from '../../utils/declaration';
import { useFeatureToggles } from '../../utils/useDataMdms';

export default function ContributorDetails({
  application,
  applicants = [],
  ifXalt,
  createdAt,
  isAccreditedInvestor,
}: {
  application: ApplicationProps;
  applicants: Partial<Applicant>[];
  ifXalt: boolean;
  createdAt: string;
  isAccreditedInvestor?: boolean;
}): JSX.Element {
  const { toggler } = useFeatureToggles();
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
            </Grid>
            {checkValidationBasedOnDate(
              createdAt || '',
              toggler.dateFeatureToggles.accredidation_Validation_Date
            ) && (
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
                sx={{ mt: 1 }}>
                <Typography
                  sx={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: 'text.secondary',
                  }}>
                  Accredited Investor:{' '}
                  <Typography
                    component="span"
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: 'rgba(0, 0, 0, 0.6)',
                      letterSpacing: '0.4px',
                      ml: 0.5,
                    }}>
                    {isAccreditedInvestor ? 'Yes' : 'No'}
                  </Typography>
                </Typography>
              </Grid>
            )}
            {applicants.map((applicant, index) => {
              return (
                <React.Fragment key={applicant.id}>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name Of Entity'} description={applicant.name} />
                      <KeyValue
                        title={'Date of Registration/Incorporation'}
                        description={formatShortDate(applicant.dateOfBirth)}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'Place of Registration/Incorporation'}
                        description={applicant.cityOfIncorporation}
                        sx={{ overflowWrap: 'anywhere' }}
                      />
                      <KeyValue
                        title={'CKYC No./CKYC Acknowledge No./KIN No'}
                        description={applicant.ckycNo}
                      />
                      {applicant.investorType && (
                        <KeyValue
                          title={'Investor Type'}
                          description={investorTypeMasters[applicant.investorType]}
                        />
                      )}
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      {isAccreditedInvestor &&
                        checkValidationBasedOnDate(
                          createdAt || '',
                          toggler.dateFeatureToggles.accredidation_Validation_Date
                        ) && (
                          <>
                            <KeyValue
                              title={'Accreditation Certificate Number'}
                              description={applicant.accreditationCertificateNumber}
                            />
                            <KeyValue
                              title={'Accreditation Certificate Start Date'}
                              description={formatShortDate(applicant.accreditationValidFrom)}
                            />
                            <KeyValue
                              title={'Accreditation Certificate End Date'}
                              description={formatShortDate(applicant.accreditationValidTo)}
                            />
                          </>
                        )}
                      {investorTypeMasters[applicant.investorType || ''] ===
                        investorTypeMasters.corporate &&
                        checkValidationBasedOnDate(
                          createdAt || '',
                          toggler.dateFeatureToggles?.npo_validation_date
                        ) && (
                          <KeyValue
                            title={'Section 8 Companies'}
                            description={YES_NO_MASTER[applicant.isCorporateEntity || '']}
                          />
                        )}
                      {checkValidationBasedOnDate(
                        application.createdAt || '',
                        reTypeValidationDate
                      ) && (
                        <>
                          <KeyValue
                            title={'RBI Regulated Entity'}
                            description={YES_NO_MASTER[applicant.rbiRegulatedEntity || '']}
                          />
                          {shouldShowRBICategory(applicant.rbiRegulatedEntity || '') && (
                            <>
                              <KeyValue
                                title={'RE Type'}
                                description={REtypeMaster[applicant.reType || '']}
                              />
                              {applicant.reType && (
                                <KeyValue
                                  title={'RBI Registration Number'}
                                  description={applicant.RBIRegNo}
                                />
                              )}
                              {/* {OthersOptionForRE(applicant.reType || '') && (
                            <KeyValue
                              title={'Other RE Type'}
                              description={applicant.reTypeOthers}
                            />
                          )} */}
                            </>
                          )}
                        </>
                      )}
                      {applicant.isNpo &&
                        checkValidationBasedOnDate(
                          createdAt || '',
                          toggler.dateFeatureToggles?.npo_validation_date
                        ) && (
                          <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                            {/* <Checkbox defaultChecked disabled={true} /> */}
                            <Typography
                              sx={{
                                fontSize: 15,
                                fontWeight: 700,
                                color: 'rgba(0, 0, 0, 0.6)',
                                letterSpacing: '0.5px',
                              }}>
                              {isNPODeclaration}
                            </Typography>
                          </Grid>
                        )}
                      {isDprFieldApplicable(
                        applicant.investorType || '',
                        applicant.isCorporateEntity || ''
                      ) &&
                        checkValidationBasedOnDate(
                          createdAt || '',
                          toggler.dateFeatureToggles?.npo_validation_date
                        ) && (
                          <KeyValue
                            title={'Darpan Portal Registration Number'}
                            description={applicant.darpanRegistrationNo}
                          />
                        )}
                      {applicant.isNotNpo &&
                        checkValidationBasedOnDate(
                          createdAt || '',
                          toggler.dateFeatureToggles?.npo_validation_date
                        ) && (
                          <Grid item xs={12} display="flex" alignItems={'flex-start'} mt={1}>
                            {/* <Checkbox defaultChecked disabled={true} /> */}
                            <Typography
                              sx={{
                                fontSize: 15,
                                fontWeight: 700,
                                color: 'rgba(0, 0, 0, 0.6)',
                                letterSpacing: '0.5px',
                              }}>
                              {isNotNPODeclaration}
                            </Typography>
                          </Grid>
                        )}
                      {/* {ifXalt &&
                        investorTypeMasters[applicant?.investorType || ''] ===
                          investorTypeMasters.boi_or_aop && (
                          <KeyValue
                            title={'AOP or BOI'}
                            description={AOI_BOI_MASTER[applicant?.boiOrAop || '']}
                          />
                        )} */}
                    </Grid>
                  </Gridstyles>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {'Other Details'}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={16}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue
                        title={'Gross Annual Income'}
                        description={applicant.grossAnnualIncome}
                      />
                      <Grid item xs={12} sm={6}>
                        <Item>{'~ Net Worth As on Current Date'}</Item>
                        <ItemDetails> {applicant.netWorth ? applicant.netWorth : '-'}</ItemDetails>
                        <ItemDetails>
                          {' '}
                          {applicant.netWorth && currencyConversion(applicant.netWorth)}
                        </ItemDetails>
                      </Grid>
                      {/* <KeyValue
                        title={'PEP Status'}
                        description={applicant.politicallyExposedPersonStatus}
                      /> */}
                      <KeyValue
                        title={'Demat Account Details (for allotment of units)'}
                        description={DLCLMasters[applicant.dlclId || '']}
                      />
                      {getdpIdField(applicant.dlclId || '') && (
                        <KeyValue
                          title={isCDSL(applicant.dlclId || '') ? 'DPCL ID' : 'DP ID'}
                          description={applicant.dpId}
                        />
                      )}
                      {getclIdField(applicant.dlclId || '') && (
                        <KeyValue title={'CL ID'} description={applicant.clId} />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
